import { Tooltip } from '@mantine/core'
import { LeaguestarState } from '../../../state'
import { Typography } from '../../typography'

export default function Version({
  component,
}: {
  component: 'navigation' | 'footer'
}) {
  const { api_build_timestamp, frontend_build_timestamp } =
    LeaguestarState.useState((state) => ({
      api_build_timestamp: state.api_build_timestamp,
      frontend_build_timestamp: state.frontend_build_timestamp,
    }))

  const versionsMismatch =
    !!frontend_build_timestamp &&
    !!api_build_timestamp &&
    api_build_timestamp !== 'unknown' &&
    frontend_build_timestamp !== api_build_timestamp

  return (
    <Tooltip
      label={
        <div>
          <div>Frontend: {frontend_build_timestamp?.replace('T', ' ')}</div>
          <div>API: {api_build_timestamp?.replace('T', ' ')}</div>
        </div>
      }
      disabled={!versionsMismatch}
    >
      <Typography
        fc={
          component === 'navigation'
            ? { light: 'gray-5', dark: 'gray-5' }
            : { light: 'white', dark: 'white' }
        }
        fs="xs"
        lh="125"
      >
        v
        {frontend_build_timestamp
          ? frontend_build_timestamp.split('T')[0].split('-').join('')
          : '-unknown'}
        {versionsMismatch
          ? ` (${api_build_timestamp!.split('T')[0].split('-').join('')})`
          : ''}
      </Typography>
    </Tooltip>
  )
}
